import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './tufts-icon-link.css.lit';
import '../tufts-icon/tufts-icon';
import { SlotNGController } from '../../controllers/slot-ng-controller';

/**
 * The TuftsIconLink component
 * @element tufts-icon-link
 *
 * @slot - icon
 * @slot - link
 *
 * @attr label
 * @attr url
 */
@customElement('tufts-icon-link')
export class TuftsIconLink extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  ngSlot = new SlotNGController(this);

  @property({
    type: String,
    reflect: true,
    attribute: 'label',
  })
  label: string;

  @property({
    type: String,
    reflect: true,
    attribute: 'url',
  })
  url: string;

  render(): TemplateResult {
    return html`
      <div class="tufts-icon-link">
        ${this.ngSlot.conditionalNGSlot('icon', true, null, [
          { name: 'aria-hidden', value: 'true' },
        ])}
        ${this.ngSlot.conditionalNGSlot('link')}
        <tufts-icon
          aria-hidden="true"
          name="right-arrow"
          library="system"
          size="1em"
          class="link-button"
        >
        </tufts-icon>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-icon-link': TuftsIconLink;
  }
}
